<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5 ml-4">
        <li>
          <router-link to="/manageRoles" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("system.label.createRole") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('system.label.name')"
            >
              <vs-input
                :label="$t('system.label.name')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="role.name"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="$t('system.label.description')"
            >
              <vs-input
                :label="$t('system.label.description')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="role.description"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
      </vx-card>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="validateForm"
            >{{ $t("system.label.submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const roleEmptyObj = {
  name: "",
  description: "",
};

export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("RBAC"), to: "" },
        { name: this.$t("system.label.roles"), to: "/manageRoles" },
        { name: this.$t("system.label.createRole"), to: "/" },
      ],
      role: roleEmptyObj,
      warningPopup: false,
      warningText: "",
      errors: [],
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      postResponse: (state) => state.manageRoles.createrole,
      errorMessage: (state) => state.manageRoles.formError,
    }),
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.createrole();
    },
    async createrole() {
      try {
        await this.$store.dispatch("manageRoles/createRoleAction", this.role);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Role Created Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push(`/manageRoles`);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetForm() {
      this.role.name = "";
      this.role.description = "";
    },
  },
  mounted() {
    this.resetForm();
  },
  watch: {},
};
</script>
<style></style>
